import BaseAccordionList from 'components/ui/controls/BaseAccordionList/BaseAccordionList.js'

export default BaseAccordionList
